module.exports = __webpack_public_path__ + "static/media/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 2.87d95b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/ALEXANDER MATERIAN - TRABAJO DE GRADO DISEÑO DE MODA 2.jpg
// module id = 786
// module chunks = 0